module.exports = __webpack_public_path__ + "static/media/oil-lube-services.f30a805c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/oil-lube-services.svg
// module id = 2546
// module chunks = 2